import { https } from '../http';

export const bookDemo = async (quizData) => {
  const res = await https().post('/auth/book-demo', quizData);
  return res.data;
};
